// ##############################################################

// #             GENEROVANÝ KÓD, NEMODIFIKOVAT!!!!              #

// #                  2025-05-22T09:54:31Z                      #

// ##############################################################


/**
 * Vyjmenované hodnoty pro seal_Source.
 */
enum EnumSealSource {
    MC = 'MC', 
    REMSIG = 'REMSIG', 
    SECUSIGN = 'SECUSIGN', 
    ICA = 'ICA', 
    QSEAL = 'QSEAL'
};
export default EnumSealSource;

/**
 * Mapa enumu na objekt s podrobnostmi o enumu.
 */
const params = {
    [EnumSealSource.MC]: {caption: ''},
    [EnumSealSource.REMSIG]: {caption: ''},
    [EnumSealSource.SECUSIGN]: {caption: ''},
    [EnumSealSource.ICA]: {caption: ''},
    [EnumSealSource.QSEAL]: {caption: ''}
};

/**
 * Načtení popisku enumu.
 * @return popisek enumu
 */
export function getCaption(value) {
    return params[value].caption;
}
